export const versionfn  ={
    version:'v2'
}
export const versiongeneral  ={
    version:'v1'
}